import { ContinentMode } from '../types';

export const COUNTRY_TO_CONTINENT: Record<string, ContinentMode> = {
  Afghanistan: 'asia',
  Algeria: 'africa',
  Angola: 'africa',
  Argentina: 'south-america',
  Armenia: 'asia',
  Austria: 'europe',
  Azerbaijan: 'asia',
  Bangladesh: 'asia',
  Belarus: 'europe',
  Belgium: 'europe',
  Bolivia: 'south-america',
  Brazil: 'south-america',
  Bulgaria: 'europe',
  'Burkina Faso': 'africa',
  Burundi: 'africa',
  Cambodia: 'asia',
  Cameroon: 'africa',
  Canada: 'north-america',
  'Central African Republic': 'africa',
  Chad: 'africa',
  Chile: 'south-america',
  China: 'asia',
  Colombia: 'south-america',
  Congo: 'africa',
  'Congo, Democratic Republic of the': 'africa',
  Cuba: 'north-america',
  'Czech Republic': 'europe',
  "Côte d'Ivoire": 'africa',
  Denmark: 'europe',
  'Dominican Republic': 'north-america',
  Ecuador: 'south-america',
  Egypt: 'africa',
  Ethiopia: 'africa',
  France: 'europe',
  Gabon: 'africa',
  Georgia: 'asia',
  Germany: 'europe',
  Ghana: 'africa',
  Guatemala: 'north-america',
  Guinea: 'africa',
  Haiti: 'north-america',
  Honduras: 'north-america',
  'Hong Kong, China': 'asia',
  Hungary: 'europe',
  India: 'asia',
  Indonesia: 'asia',
  'Iran, Islamic Rep. of': 'asia',
  Iraq: 'asia',
  Ireland: 'europe',
  Israel: 'asia',
  Italy: 'europe',
  Jamaica: 'north-america',
  Japan: 'asia',
  Jordan: 'asia',
  Kazakhstan: 'asia',
  Kenya: 'africa',
  "Korea, Dem. People's Rep. of": 'asia',
  'Korea, Republic of': 'asia',
  Kyrgyzstan: 'asia',
  Lebanon: 'asia',
  Liberia: 'africa',
  'Libyan Arab Jamahiriya': 'africa',
  Madagascar: 'africa',
  Malawi: 'africa',
  Malaysia: 'asia',
  Mali: 'africa',
  Mauritania: 'africa',
  Mexico: 'north-america',
  Mongolia: 'asia',
  Morocco: 'africa',
  Mozambique: 'africa',
  Myanmar: 'asia',
  Nepal: 'asia',
  Nicaragua: 'north-america',
  Niger: 'africa',
  Nigeria: 'africa',
  Oman: 'asia',
  Pakistan: 'asia',
  Paraguay: 'south-america',
  Peru: 'south-america',
  Philippines: 'asia',
  Poland: 'europe',
  Romania: 'europe',
  'Russian Federation': 'europe',
  Rwanda: 'africa',
  'Saudi Arabia': 'asia',
  Senegal: 'africa',
  Serbia: 'europe',
  'Sierra Leone': 'africa',
  Singapore: 'asia',
  Somalia: 'africa',
  'South Africa': 'africa',
  Spain: 'europe',
  'Sudan, The Republic of': 'africa',
  Sweden: 'europe',
  'Syrian Arab Republic': 'asia',
  'Taiwan, China': 'asia',
  'Tanzania, United Republic of': 'africa',
  Thailand: 'asia',
  Turkey: 'asia',
  Uganda: 'africa',
  Ukraine: 'europe',
  'United Arab Emirates': 'asia',
  'United Kingdom': 'europe',
  'United States': 'north-america',
  Uruguay: 'south-america',
  Uzbekistan: 'asia',
  'Venezuela, Bolivarian Rep. of': 'south-america',
  'Viet Nam': 'asia',
  Yemen: 'asia',
  Zambia: 'africa',
  Zimbabwe: 'africa',
};
